import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import Spinner from 'react-bootstrap/Spinner';

const GlobalSpinner = () => {
  const isLoading = useSelector((state) => state.loading.isLoading);
  const [showDelayMessage, setShowDelayMessage] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    if (isLoading) {
      // Iniciar temporizador cuando comienza la carga
      timerRef.current = setTimeout(() => {
        setShowDelayMessage(true);
      }, 5000); // 5 segundos
    } else {
      // Limpiar temporizador cuando termina la carga
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      setShowDelayMessage(false);
    }

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [isLoading]);

  if (!isLoading) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        zIndex: 1050,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: 'Arial, sans-serif',
      }}
    >
      {/* Spinner con estilo rojo/blanco */}
      <Spinner 
        animation="border" 
        style={{ 
          width: '4rem', 
          height: '4rem',
          color: '#E31937',
          borderWidth: '0.35rem',
          marginBottom: '20px'
        }} 
      />
      
      {/* Mensaje de carga normal */}
      <p style={{ 
        color: '#333',
        marginBottom: '10px',
        fontWeight: 'bold'
      }}>
        Procesando solicitud...
      </p>
      
      {/* Mensaje de demora */}
      {showDelayMessage && (
        <p style={{ 
          color: '#E31937',
          fontWeight: 'bold',
          fontSize: '0.9rem',
          maxWidth: '300px',
          textAlign: 'center'
        }}>
          El proceso está tomando más tiempo de lo esperado. Por favor, espere...
        </p>
      )}
      
      {/* Logo del sindicato */}
      <div style={{
        position: 'absolute',
        bottom: '20px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '8px'
      }}>
        <img 
          src="https://api.sinterec.cl/public/images/SINTEREC_logo.jpg" 
          alt="Logo SINTEREC" 
          style={{
            height: '40px',
            width: 'auto',
            objectFit: 'contain'
          }}
        />
        <span style={{
          fontSize: '0.8rem',
          color: '#E31937',
          fontWeight: 'bold'
        }}>
          Sinterec.cl
        </span>
      </div>
    </div>
  );
};

export default GlobalSpinner;